export const EMPTY_OPTIONS = "Ничего не найдено";